module.exports = __webpack_public_path__ + "static/media/masthead-1-col.aadc3641.svg";